import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Calendar, AlertCircle, Home, FileText } from 'lucide-react';
export const WhatYouGet = () => {
  const items = [{
    icon: BookOpen,
    title: 'El Manual Maestro "Método ADORMECER"',
    desc: 'La hoja de ruta paso a paso desde el día 1 al 14.'
  }, {
    icon: Calendar,
    title: 'La Tabla de Ventanas de Vigilia',
    desc: 'Los tiempos exactos de sueño según la edad (de 4 a 24 meses).'
  }, {
    icon: AlertCircle,
    title: 'El Protocolo del Semáforo',
    desc: 'Una guía visual para saber exactamente cuándo intervenir y cuándo esperar.'
  }, {
    icon: Home,
    title: 'Checklist de la Habitación "Cueva"',
    desc: 'Auditoría rápida para eliminar los saboteadores del sueño en tu hogar.'
  }, {
    icon: FileText,
    title: 'Diario de Seguimiento Imprimible',
    desc: 'Para monitorizar el progreso y ver las victorias reales cada mañana.'
  }];
  return <section className="py-16 md:py-24 px-6 max-w-5xl mx-auto" data-id="element-99">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-center mb-16" data-id="element-100">
        <h2 className="text-3xl md:text-4xl font-serif text-charcoal" data-id="element-101">
          ¿Qué incluye el programa?
        </h2>
      </motion.div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-102">
        {items.map((item, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="bg-white p-8 rounded-2xl shadow-sm border border-sand/30 hover:shadow-md transition-shadow" data-id="element-103">
            <div className="bg-beige w-12 h-12 rounded-full flex items-center justify-center text-terracotta mb-6" data-id="element-104">
              <item.icon size={24} data-id="element-105" />
            </div>
            <h3 className="font-serif text-xl text-charcoal mb-3" data-id="element-106">
              {item.title}
            </h3>
            <p className="text-charcoal/70 leading-relaxed" data-id="element-107">{item.desc}</p>
          </motion.div>)}
      </div>
    </section>;
};